module.exports = __webpack_public_path__ + "img/archway-small.5ed4d80d.svg";